import { isFeatureEnabled } from 'owa-feature-flags';

export function is3PCustomPropertiesEnabled(): boolean {
    return isFeatureEnabled('peo-3p-custom-properties');
}
